import { resolveResourceEnvironment } from "./environment.ts";
import type { CreateLockerverseWidgetOptions } from "./types.ts";

export function resolveWidgetEnvironment(
  options: CreateLockerverseWidgetOptions
) {
  const runtime = resolveResourceEnvironment(options, "widgetSlug");
  return {
    ...runtime,
    widgetSlug: runtime.resourceSlug,
    widgetSlugValue: runtime.resourceSlugValue,
  };
}
